import { polyfill } from 'mobile-drag-drop';
import 'mobile-drag-drop/default.css';

window.addEventListener('touchmove', function() {});

polyfill();
